import { getCheckoutIdByRegionAndProductHandler } from '../application/get-checkout-id-by-region-and-product';
import { getCheckoutPathHandler } from '../application/get-new-checkout-path';
import { checkoutRepository } from '../infrastructure/checkout.repository';

export const getCheckoutIdPathByRegionAndProduct = getCheckoutIdByRegionAndProductHandler(checkoutRepository);
export const getNewCheckoutUrlPath = getCheckoutPathHandler(checkoutRepository);
